/**
 * Pemformat tampilan. ⚠️ **Hanya untuk MATA** — setiap hitungan uang tetap milik server (P1).
 *
 * ⭐ Dipindah ke sini saat layar PELAYAN lahir: fungsi yang sama dibutuhkan dua shell, dan menyalin
 * pemformat uang adalah cara paling mudah membuat dua layar menampilkan angka yang berbeda untuk
 * data yang sama — persis jenis perbedaan yang tak ada yang menyadarinya sampai tamu bertanya.
 */

/** Format rupiah dari string desimal kanonik. */
export function formatRupiah(canonical: string): string {
  const bulat = canonical.split('.')[0] ?? '0';
  return `Rp ${bulat.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
}
